import Vue from "vue";

export default {
    async getVisibleCurrencies() {
        await Vue.state.currencies.ensure();
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        let currencies = Vue.state.currencies.get();

        let visibleCurrencies = null;

        if (client.view.payments.visibleCurrencies && client.view.payments.visibleCurrencies.length) {
            visibleCurrencies = currencies.filter(c => client.view.payments.visibleCurrencies.indexOf(c.id) >= 0)
        }

        return visibleCurrencies;
    }
}


// WEBPACK FOOTER //
// ./_common/helpers/currency.helper.js